import type { AvailableParts } from '@/types/Certificate';

/**
 * Takes the html of a question stem that may or may not contain an img tag
 * and formats the src to be an absolute url in order to properly retrieve the image
 *
 * Regex Matching Groups:
 * 1. Certificate Acronym
 * 2. Image Filename, including extension
 * 3. Image Extension
 * 4. Everything else in the img tag
 * @param string html
 * @returns formatted html string
 */
function formatQuestionImage(html: string, part: AvailableParts): string {
    const regex = /<img src="get-image.php\?path=(\w+)\/images\/([\w-]+\.(jpg|jpeg|png|gif))"([^>]*)?\/>/g;
    const subst = `<img src="${import.meta.env.VITE_FSUM_API_URL}/v2/media/images/${part}/$1/$2"$4/>`;

    const result = html.replace(regex, subst);

    return result;
}

export {
    formatQuestionImage,
};
